export const loveImg = require("../../../assets/media/love.png");


// WEBPACK FOOTER //
// ./src/screens/AutoConcierge/constants/assets.js